if ($('.reviews__carousel').length > 0) {
  let initialSlide = 0;
  const $reviewsCarousel = $('.reviews__carousel');

  $reviewsCarousel.each(function(index, el) {
    const isActive = $(this).hasClass("active");
    if(isActive) {
      initialSlide = index;
    }
  })

  const $progressBar = $('.reviews-carousel .progress');
  const $progressBarLabel = $( '.reviews-carousel .slider__label' );

  $reviewsCarousel.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    let calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;

    if ($(window).width() >= 768){
      if (calc > 56){
        calc = 100;
      }
    }

    if (calc === 0) {
      calc = 15;
    }

    $progressBar
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc );

    $progressBarLabel.text( calc + '% completed' );
  });


  $reviewsCarousel.slick({
    infinite: false,
    dots: false,
    centerMode: false,
    centerPadding: '20px',
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: false,
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          infinite: false,
          dots: false,
          centerMode: false,
          centerPadding: '20px',
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: false,
          initialSlide: initialSlide,
        }
      },
      {
        breakpoint: 990,
        settings: {
          infinite: false,
          dots: false,
          centerMode: true,
          centerPadding: '22px',
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          initialSlide: initialSlide,
        }
      }
    ]
  });
}